const COMMON_POLLING_INTERVAL = 12000
const DAY_CHART_POLLING_INTERVAL = 60 * 4 * 1000
const SITE_POLLING_INTERVAL = COMMON_POLLING_INTERVAL
const THING_POLLING_INTERVAL = COMMON_POLLING_INTERVAL
const MODE_VIEW = 'view'
const MODE_EDIT = 'edit'
const SITE_SCHEMA_EDITOR_ICON_SIZE = { width: 24, height: 32 }
const SITE_SCHEMA_SCROLLBAR_OFFSET = 25
const SITE_SCHEMA_FONT_SIZE = 20
const NUMBER_DEVICES_FOR_FILTER = 4
const TIME_FORMAT = 'DD.MM.YYYY HH:mm'
const DATE_FORMAT = 'DD.MM.YYYY'
const EXPORT_MAX_THINGS = 100

const KEYS = {

        STATE_OF_CHARGE: 'STATE_OF_CHARGE',

        FLOW_TEMPERATURE: 'FLOW_TEMPERATURE',

        RETURN_TEMPERATURE: 'RETURN_TEMPERATURE',

        MAX_TEMPERATURE: 'MAX_TEMPERATURE',

        VOLUME_FLOW_RATE: 'VOLUME_FLOW_RATE',

        FLOWED_VOLUME: 'FLOWED_VOLUME',

        REMOTE_CONTROL_ACTIVE: 'REMOTE_CONTROL_ACTIVE',

        CHARGED_ENERGY: 'CHARGED_ENERGY',

        CHARGING_PROCESS_ENERGY: 'CHARGING_PROCESS_ENERGY',

        DISCHARGED_ENERGY: 'DISCHARGED_ENERGY',

        CAPACITY: 'CAPACITY',

        CHARGING_CYCLES: 'CHARGING_CYCLES',

        HEALTH_STATE: 'HEALTH_STATE',

        CELL_TEMPERATURE: 'CELL_TEMPERATURE',

        MAX_CELL_TEMPERATURE: 'MAX_CELL_TEMPERATURE',

        MIN_CELL_TEMPERATURE: 'MIN_CELL_TEMPERATURE',

        MAX_CELL_VOLTAGE: 'MAX_CELL_VOLTAGE',

        MIN_CELL_VOLTAGE: 'MIN_CELL_VOLTAGE',

        MAX_CELL_TEMPERATURE_NUMBER: 'MAX_CELL_TEMPERATURE_NUMBER',

        MIN_CELL_TEMPERATURE_NUMBER: 'MIN_CELL_TEMPERATURE_NUMBER',

        MAX_CELL_VOLTAGE_NUMBER: 'MAX_CELL_VOLTAGE_NUMBER',

        MIN_CELL_VOLTAGE_NUMBER: 'MIN_CELL_VOLTAGE_NUMBER',

        RACK_TEMPERATURES: 'RACK_TEMPERATURES',

        RACK_HUMIDITIES: 'RACK_HUMIDITIES',

        HEATSINK_TEMPERATURES: 'HEATSINK_TEMPERATURES',

        MAX_SOC: 'MAX_SOC',

        MIN_SOC: 'MIN_SOC',

        INSTALLED_CAPACITY: 'INSTALLED_CAPACITY',

        INSTALLED_POWER: 'INSTALLED_POWER',

        MAX_POWER_CHARGE: 'MAX_POWER_CHARGE',

        ACTIVE_POWER_LIMIT: 'ACTIVE_POWER_LIMIT',

        MAX_POWER_DISCHARGE: 'MAX_POWER_DISCHARGE',

        MAX_POWER_GRID_FEED_IN: 'MAX_POWER_GRID_FEED_IN',

        MAX_POWER_GRID_SUPPLY: 'MAX_POWER_GRID_SUPPLY',

        GRID_STANDARD: 'GRID_STANDARD',

        POWER_CONTROL_MODE_REACTIVE: 'POWER_CONTROL_MODE_REACTIVE',

        EPS_ENABLED: 'EPS_ENABLED',

        EXTERNAL_SHUTDOWN_ENABLED: 'EXTERNAL_SHUTDOWN_ENABLED',

        TEMPERATURES: 'TEMPERATURES',

        HOT_WATER_OUTLET_TEMPERATURE: 'HOT_WATER_OUTLET_TEMPERATURE',

        HEATING_OUTLET_TEMPERATURES: 'HEATING_OUTLET_TEMPERATURES',

        CP_STATE_CODE: 'CP_STATE_CODE',

        EV_STATE_CODE: 'EV_STATE_CODE',

        START_STOP_CHARGING: 'START_STOP_CHARGING',

        STATION_AVAILABILITY: 'STATION_AVAILABILITY',

        CONSUMED_ENERGY_TOTAL: 'CONSUMED_ENERGY_TOTAL',

        CONSUMED_ENERGY_ACTUAL: 'CONSUMED_ENERGY_ACTUAL',

        LAST_RFID_CARD: 'LAST_RFID_CARD',

        MAX_CURRENT_CHARGE: 'MAX_CURRENT_CHARGE',

        MAX_CURRENT_DISCHARGE: 'MAX_CURRENT_DISCHARGE',

        HARMONICS: 'HARMONICS',

        TOTAL_HARMONIC_DISTORTION: 'TOTAL_HARMONIC_DISTORTION',

        DISTORTION_FACTOR: 'DISTORTION_FACTOR',

        VOLTAGE_P1_P2: 'VOLTAGE_P1_P2',

        VOLTAGE_P2_P3: 'VOLTAGE_P2_P3',

        VOLTAGE_P3_P1: 'VOLTAGE_P3_P1',

        ACTIVE_VOLTAGE: 'ACTIVE_VOLTAGE',

        REACTIVE_VOLTAGE: 'REACTIVE_VOLTAGE',

        TOTAL_VOLTAGE: 'TOTAL_VOLTAGE',

        ACTIVE_CURRENT: 'ACTIVE_CURRENT',

        REACTIVE_CURRENT: 'REACTIVE_CURRENT',

        TOTAL_CURRENT: 'TOTAL_CURRENT',

        CONSUMED_ENERGY: 'CONSUMED_ENERGY',

        DELIVERED_ENERGY: 'DELIVERED_ENERGY',

        IMPORTED_ENERGY: 'IMPORTED_ENERGY',

        EXPORTED_ENERGY: 'EXPORTED_ENERGY',

        HEATING_ENERGY: 'HEATING_ENERGY',

        COOLING_ENERGY: 'COOLING_ENERGY',

        FUEL_LEVEL: 'FUEL_LEVEL',

        FUEL_CONSUMPTION: 'FUEL_CONSUMPTION',

        FUEL_CONSUMPTION_ACTUAL: 'FUEL_CONSUMPTION_ACTUAL',

        COOLANT_TEMPERATURE: 'COOLANT_TEMPERATURE',

        OIL_TEMPERATURE: 'OIL_TEMPERATURE',

        OIL_PRESSURE: 'OIL_PRESSURE',

        COP: 'COP',

        ANNUAL_COP: 'ANNUAL_COP',

        ELECTRICAL_ENERGY: 'ELECTRICAL_ENERGY',

        THERMAL_ENERGY: 'THERMAL_ENERGY',

        ELECTRICAL_POWER: 'ELECTRICAL_POWER',

        THERMAL_POWER: 'THERMAL_POWER',

        REFRIGERANT_FLOW_TEMPERATURE: 'REFRIGERANT_FLOW_TEMPERATURE',

        REFRIGERANT_RETURN_TEMPERATURE: 'REFRIGERANT_RETURN_TEMPERATURE',

        ENVIRONMENTAL_INLET_TEMPERATURE: 'ENVIRONMENTAL_INLET_TEMPERATURE',

        ENVIRONMENTAL_OUTLET_TEMPERATURE: 'ENVIRONMENTAL_OUTLET_TEMPERATURE',

        ROOM_TEMPERATURE: 'ROOM_TEMPERATURE',

        TARGET_ROOM_TEMPERATURE: 'TARGET_ROOM_TEMPERATURE',

        HC_OUTDOOR_TEMPERATURE: 'HC_OUTDOOR_TEMPERATURE',

        HC_PARALLEL_SHIFT: 'HC_PARALLEL_SHIFT',

        HC_SLOPE: 'HC_SLOPE',

        LOCK_UNTIL: 'LOCK_UNTIL',

        INPUTS_POWER: 'INPUTS_POWER',

        INPUT_POWER: 'INPUT_POWER',

        PRODUCED_ENERGY: 'PRODUCED_ENERGY',

        VOLTAGES: 'VOLTAGES',

        CURRENTS: 'CURRENTS',

        VALVE_POSITION: 'VALVE_POSITION',

        TARGET_TEMPERATURE: 'TARGET_TEMPERATURE',

        SELF_SUFFICIENCY: 'SELF_SUFFICIENCY',

        ENERGY_PRODUCED: 'ENERGY_PRODUCED',

        ENERGY_CONSUMED: 'ENERGY_CONSUMED',

        ENERGY_CONSUMED_CALC: 'ENERGY_CONSUMED_CALC',

        ENERGY_IMPORTED: 'ENERGY_IMPORTED',

        ENERGY_EXPORTED: 'ENERGY_EXPORTED',

        ENERGY_CHARGED: 'ENERGY_CHARGED',

        ENERGY_DISCHARGED: 'ENERGY_DISCHARGED',

        POWER_PRODUCTION: 'POWER_PRODUCTION',

        POWER_CONSUMPTION: 'POWER_CONSUMPTION',

        POWER_CONSUMPTION_CALC: 'POWER_CONSUMPTION_CALC',

        POWER_GRID: 'POWER_GRID',

        POWER_GRID_REMAINING: 'POWER_GRID_REMAINING',

        POWER_STORAGE: 'POWER_STORAGE',

        ENERGY_APPLIANCES: 'ENERGY_APPLIANCES',

        ENERGY_CHARGING_STATIONS: 'ENERGY_CHARGING_STATIONS',

        ENERGY_HEATING: 'ENERGY_HEATING',

        POWER_APPLIANCES: 'POWER_APPLIANCES',

        POWER_CHARGING_STATIONS: 'POWER_CHARGING_STATIONS',

        POWER_HEATING: 'POWER_HEATING',

        INPUT_ENERGY: 'INPUT_ENERGY',

        OUTPUT_ENERGY: 'OUTPUT_ENERGY',

        MIN_SOC_FEED_IN_OPT: 'MIN_SOC_FEED_IN_OPT',

        MAX_GRID_POWER_FEED_IN_OPT: 'MAX_GRID_POWER_FEED_IN_OPT',

        MIN_SOC_PEAK_SHAVING_OPT: 'MIN_SOC_PEAK_SHAVING_OPT',

        MAX_GRID_POWER_PEAK_SHAVING: 'MAX_GRID_POWER_PEAK_SHAVING',

        MIN_SOC_BLACKOUT: 'MIN_SOC_BLACKOUT',

        MIN_SOC_BACKUP_ENERGY: 'MIN_SOC_BACKUP_ENERGY',

        MIN_SOC_SELF_CONSUMPTION_OPT: 'MIN_SOC_SELF_CONSUMPTION_OPT',

        LOAD_SHEDDING_LEVELS: 'LOAD_SHEDDING_LEVELS',

        CHARGING_STRATEGY: 'CHARGING_STRATEGY',

        EMS_MIN_POWER_CHARGE: 'EMS_MIN_POWER_CHARGE',

        POWER_THRESHOLD_RECOMMENDED_OP: 'POWER_THRESHOLD_RECOMMENDED_OP',

        POWER_THRESHOLD_NORMAL_OP: 'POWER_THRESHOLD_NORMAL_OP',

        CONTROLLER_MODE: 'CONTROLLER_MODE',

        PAUSE_CHARGING: 'PAUSE_CHARGING',

        TARGET_LOCAL_POWER_OFFSET: 'TARGET_LOCAL_POWER_OFFSET',

        OVERALL_GRID_CONNECTED: 'OVERALL_GRID_CONNECTED',

        OVERALL_SYSTEM_AVAILABLE: 'OVERALL_SYSTEM_AVAILABLE',

        OVERALL_SYSTEM_RUNNING: 'OVERALL_SYSTEM_RUNNING',

        OVERALL_SYSTEM_FAILURE: 'OVERALL_SYSTEM_FAILURE',

        OVERALL_ACTIVE_POWER: 'OVERALL_ACTIVE_POWER',

        OVERALL_LOCAL_POWER: 'OVERALL_LOCAL_POWER',

        OVERALL_AVAILABLE_POWER_CHARGE: 'OVERALL_AVAILABLE_POWER_CHARGE',

        OVERALL_AVAILABLE_POWER_DISCHARGE: 'OVERALL_AVAILABLE_POWER_DISCHARGE',

        OVERALL_STATE_OF_CHARGE: 'OVERALL_STATE_OF_CHARGE',

        OVERALL_MAX_SOC: 'OVERALL_MAX_SOC',

        OVERALL_MIN_SOC: 'OVERALL_MIN_SOC',

        OVERALL_REMAINING_ENERGY_CHARGE: 'OVERALL_REMAINING_ENERGY_CHARGE',

        OVERALL_REMAINING_ENERGY_DISCHARGE: 'OVERALL_REMAINING_ENERGY_DISCHARGE',

        OPERATING_MODE_SG_READY: 'OPERATING_MODE_SG_READY',

        GRID_LIMITATION_BITMASK: 'GRID_LIMITATION_BITMASK',

        EPS_MODE_ACTIVE: 'EPS_MODE_ACTIVE',

        POWER_P3: 'POWER_P3',

        VALUE: 'VALUE',

        CHARGING_TIME: 'CHARGING_TIME',

        OPERATING_HOURS: 'OPERATING_HOURS',

        VOLTAGE: 'VOLTAGE',

        CONNECTION: 'CONNECTION',

        CONNECTIONS: 'CONNECTIONS',

        STATE_CODE: 'STATE_CODE',

        ERROR_CODES: 'ERROR_CODES',

        ACKNOWLEDGE_ERRORS: 'ACKNOWLEDGE_ERRORS',

        ON_OFF: 'ON_OFF',

        OPERATING_MODE: 'OPERATING_MODE',

        OPERATING_MODE_EMS: 'OPERATING_MODE_EMS',

        TARGET_POWER: 'TARGET_POWER',

        EXCESS_POWER: 'EXCESS_POWER',

        RATED_POWER: 'RATED_POWER',

        CURRENT: 'CURRENT',

        POWER: 'POWER',

        REACTIVE_POWER: 'REACTIVE_POWER',

        APPARENT_POWER: 'APPARENT_POWER',

        ACTIVE_POWER: 'ACTIVE_POWER',

        POWER_FACTOR: 'POWER_FACTOR',

        VOLTAGE_P1: 'VOLTAGE_P1',

        VOLTAGE_P2: 'VOLTAGE_P2',

        FREQUENCY: 'FREQUENCY',

        VOLTAGE_P3: 'VOLTAGE_P3',

        CURRENT_P1: 'CURRENT_P1',

        CURRENT_P2: 'CURRENT_P2',

        POWER_P1: 'POWER_P1',

        POWER_P2: 'POWER_P2',

        CURRENT_P3: 'CURRENT_P3',

        MAX_POWER: 'MAX_POWER'

}

// TODO: ELECTRICITY_METER & ENERGY_METER & SMART_METER are DEPRECATED, remove when fully merged
const CHARGING_POINT_TYPES = [
    'CHARGING_POINT_DC',
    'CHARGING_POINT_AC'
]
const METER_TYPES = [
    'SMART_METER',
    'ELECTRICITY_METER',
    'ENERGY_METER',
    'ELECTRICITY_METER_AC',
    'ELECTRIC_CIRCUIT'
]

const THING_CONTROLS_SUPPORTED_KEYS = [
    'ON_OFF',
    'STATION_AVAILABILITY',
    'START_STOP_CHARGING',
    'OPERATING_MODE',
    'OPERATING_MODE_EMS',
    'CONTROLLER_MODE',
    'HC_PARALLEL_SHIFT',
    'HC_SLOPE',
    'TARGET_TEMPERATURE',
    'TARGET_ROOM_TEMPERATURE',
    'VALVE_POSITION',
    'MAX_POWER_CHARGE',
    'MAX_POWER_DISCHARGE',
    'MAX_CURRENT_CHARGE',
    'MAX_CURRENT_DISCHARGE',
    'STATE_OF_CHARGE',
    'MIN_SOC',
    'MAX_SOC',
    'TARGET_POWER',
    'MIN_SOC_FEED_IN_OPT',
    'MIN_SOC_SELF_CONSUMPTION_OPT',
    'MIN_SOC_PEAK_SHAVING_OPT',
    'MIN_SOC_BACKUP_ENERGY',
    'MAX_GRID_POWER_FEED_IN_OPT',
    'MAX_GRID_POWER_PEAK_SHAVING',
    'MIN_SOC_BLACKOUT',
    'LOAD_SHEDDING_LEVELS',
    'OPERATING_MODE_EMS',
    'EMS_MIN_POWER_CHARGE',
    'EV_STATE_CODE',
    'POWER_THRESHOLD_RECOMMENDED_OP',
    'POWER_THRESHOLD_NORMAL_OP',
    'BATTERY_CHARGE_FROM_GRID_ALLOWED',
    'BATTERY_DISCHARGE_TO_GRID_ALLOWED'
]

const THING_CONTROLS_SUPPORTED_SETTINGS = [
    'OPERATING_MODE_EMS',
    'POWER_THRESHOLD_RECOMMENDED_OP',
    'POWER_THRESHOLD_NORMAL_OP'
]

const THING_CONTROLS_CHARGE_KEYS = [
    'MAX_POWER_CHARGE',
    'MAX_POWER_DISCHARGE',
    'MAX_CURRENT_CHARGE',
    'MAX_CURRENT_DISCHARGE'
]

const THING_TYPE = {

        CONSUMER: 'CONSUMER',

        BATTERY: 'BATTERY',

        BUFFER_TANK: 'BUFFER_TANK',

        CHARGING_POINT_DC: 'CHARGING_POINT_DC',

        CHARGING_POINT_AC: 'CHARGING_POINT_AC',

        SIMPLE_THING: 'SIMPLE_THING',

        ELECTRIC_CIRCUIT: 'ELECTRIC_CIRCUIT',

        ELECTRICITY_METER_AC: 'ELECTRICITY_METER_AC',

        ELECTRICITY_METER: 'ELECTRICITY_METER',

        ENERGY_METER: 'ENERGY_METER',

        SMART_METER: 'SMART_METER',

        HEAT_PUMP: 'HEAT_PUMP',

        HOT_WATER_TANK: 'HOT_WATER_TANK',

        INVERTER: 'INVERTER',

        PHOTOVOLTAIC: 'PV',

        THERMAL_METER: 'THERMAL_METER',

        HOT_WATER_CIRCUIT: 'HOT_WATER_CIRCUIT',

        HEATING_CIRCUIT: 'HEATING_CIRCUIT',

        EDGE_DEVICE: 'EDGE_DEVICE',

        FUEL_GENERATOR: 'FUEL_GENERATOR',

        HEATING_ROD: 'HEATING_ROD',

        CLIENT_THING: 'CLIENT_THING',

        VIRTUAL_THING: 'VIRTUAL_THING',

}

const AVAILABLE_THING_TYPES = Object.values(THING_TYPE)

const DEPRECATED_THING_TYPES = [
    'SMART_METER',
    'ELECTRICITY_METER',
    'ENERGY_METER'
]

const METER_READING_PROVIDER_TYPES = [
    'PV',
    'BATTERY',
    'CHARGING_POINT_DC',
    'CHARGING_POINT_AC',
    'ELECTRIC_CIRCUIT',
    'ELECTRICITY_METER_AC',
    'ELECTRICITY_METER',
    'ENERGY_METER',
    'SMART_METER',
    'HEAT_PUMP',
    'THERMAL_METER',
    'FUEL_GENERATOR',
    'HOT_WATER_CIRCUIT',
    'HEATING_CIRCUIT',
    'HEATING_ROD'
]

const EMS_CONTROLLED_KEYS = {

        CHARGING_POINT_AC: ['MAX_CURRENT_CHARGE','MAX_POWER_CHARGE','MAX_CURRENT_DISCHARGE','MAX_POWER_DISCHARGE'],

        CHARGING_POINT_DC: ['MAX_CURRENT_CHARGE','MAX_POWER_CHARGE','MAX_CURRENT_DISCHARGE','MAX_POWER_DISCHARGE'],

        BATTERY: ['TARGET_POWER','OPERATING_MODE'],

}

const GRID_LIMITATION_SOURCE_SIGNALS = {
    RIPPLE_CONTROL: 'RIPPLE_CONTROL',
    PARAGRAPH_9: 'PARAGRAPH_9'
}

const METER_READING_KEYS = [
  'CHARGED_ENERGY','DISCHARGED_ENERGY','PRODUCED_ENERGY','CONSUMED_ENERGY','INPUT_ENERGY','OUTPUT_ENERGY','IMPORTED_ENERGY','EXPORTED_ENERGY','DELIVERED_ENERGY','CONSUMED_ENERGY_TOTAL','ELECTRICAL_ENERGY','FLOWED_VOLUME','HEATING_ENERGY','COOLING_ENERGY','THERMAL_ENERGY','VALUE','FUEL_CONSUMPTION'
]

const COLOR_ENERGY_PRODUCED = '#FED766'
const COLOR_POWER_GRID = '#848C8E'
const COLOR_POWER_STORAGES = '#00A676'
const COLOR_ENERGY_CONSUMED = '#007DA0'
const COLOR_STATE_OF_CHARGE = '#D64C48'

const COLOR_PRIMARY = '#007DA0'
const COLOR_GREY_LIGHTER = '#f8f9fa'
const COLOR_GREY_MEDIUM = '#dae0e5'
const COLOR_GREY_DARKER = '#bcbcbc'
const COLOR_GREY_BLUE_DARK = '#343a40'

export const GENERIC_MANUFACTURER_ID = 'generic-manufacturer-id'

export const OCPP_JSON = 'OCPP_JSON'
export const MODBUS_TCP = 'MODBUS_TCP'
export const MODBUS_RTU = 'MODBUS_RTU'
export const HTTP = 'HTTP'
export const LOCAL_API_HTTP = 'LOCAL_API_HTTP'
export const EEBUS = 'EEBUS'
export const NONE = 'NONE'

export const UI_TRUNCATION_CUT_OFF_0 = '5'
export const UI_TRUNCATION_CUT_OFF_1000 = '0.005'

export default {
    COMMON_POLLING_INTERVAL,
    SITE_POLLING_INTERVAL,
    THING_POLLING_INTERVAL,
    DAY_CHART_POLLING_INTERVAL,
    MODE_VIEW,
    MODE_EDIT,
    SITE_SCHEMA_EDITOR_ICON_SIZE,
    SITE_SCHEMA_SCROLLBAR_OFFSET,
    SITE_SCHEMA_FONT_SIZE,
    NUMBER_DEVICES_FOR_FILTER,
    TIME_FORMAT,
    DATE_FORMAT,
    CHARGING_POINT_TYPES,
    METER_TYPES,
    AVAILABLE_THING_TYPES,
    DEPRECATED_THING_TYPES,
    METER_READING_PROVIDER_TYPES,
    METER_READING_KEYS,
    THING_CONTROLS_SUPPORTED_KEYS,
    THING_CONTROLS_SUPPORTED_SETTINGS,
    THING_CONTROLS_CHARGE_KEYS,
    OCPP_JSON,
    MODBUS_TCP,
    MODBUS_RTU,
    HTTP,
    COLOR_ENERGY_PRODUCED,
    COLOR_POWER_GRID,
    COLOR_POWER_STORAGES,
    COLOR_ENERGY_CONSUMED,
    COLOR_STATE_OF_CHARGE,
    COLOR_PRIMARY,
    COLOR_GREY_LIGHTER,
    COLOR_GREY_MEDIUM,
    COLOR_GREY_DARKER,
    COLOR_GREY_BLUE_DARK,
    EXPORT_MAX_THINGS,
    THING_TYPE,
    EMS_CONTROLLED_KEYS,
    GRID_LIMITATION_SOURCE_SIGNALS,
    KEYS,
    UI_TRUNCATION_CUT_OFF_0,
    UI_TRUNCATION_CUT_OFF_1000,
    GENERIC_MANUFACTURER_ID
}
